import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const FiltersOption: LazyOption = createLazyOption(
    {
        key: 'filtersOption',
        titleStringKey: 'optionTitle_filters',
        searchTermsStringKey: 'optionTitle_filters',
        isHidden: () => {
            return !isFeatureEnabled('tri-spamV2') || IsShadowMailboxUser();
        },
    },
    lazyFullModule,
    m => m.default
);
export default FiltersOption;
